

class Core {
    constructor() {
        this.currentTimeout = null;
    };
    wait(timeout) {
        if (this.currentTimeout) {
            clearTimeout(this.currentTimeout);
        };
        return new Promise(resolve => {
            this.currentTimeout = setTimeout(resolve, timeout);
        });
    };
};
var currentPool;
window.currentPool = currentPool;
window.addEventListener("load", function () {
    const dndPromotion = window.libraryMainsite.promotion;
    let globalCount;
    async function animationRandom(count, elementResult) {
        const listItem = $('.effect__item');

        // Xóa class active và ảnh trước
        listItem.removeClass('MS__active');
        listItem.addClass('MS__off');


        if (globalCount < 1) {
         
            const getItemResult = listItem.filter(function () {
                return $(this).data('stt') === elementResult;
            });
            $(getItemResult).removeClass('MS__off').addClass('MS__active');
           $('.xucxac').removeClass('active');
            return;
        }

        globalCount = count - 1;
        const randomNumber = Math.floor(Math.random() * listItem.length);
        const target = $(listItem[randomNumber]);
        target.removeClass('MS__off').addClass('MS__active');

       

        await new Core().wait(150);
        animationRandom(globalCount, elementResult);
    };

    dndPromotion({
        url: prodTemplate.url,
        debug: prodTemplate.debug,
        directory: prodTemplate.directory,
        items: prodTemplate.items,
        names: prodTemplate.names,
        config: {
            timeWait: 1500,
        },
        animResult: function (listPrize) {
            $('.xucxac').addClass('active');

            var displayPrize = listPrize[0];
            var prizeIndex = displayPrize.indexImg;
            animationRandom(10, prizeIndex);
        },
        callback: function () {
            if (typeof prodTemplate.fnPromotion === "function") prodTemplate.fnPromotion();
            globalCount = 10;
            $('.effect__item').removeClass('MS__active');
            // $('.effect__item').addClass('MS__off');
            $('.effect__item').removeClass('MS__off');
            
        },
    })

});
